export const stats = [
  { value: "28,600+", label: "累计收到投稿线索" },
  { value: "1,940", label: "已完成交叉核验" },
  { value: "72h", label: "平均首次反馈时间" },
  { value: "100%", label: "爆料来源匿名保护" },
];

export const processSteps = [
  {
    id: "01",
    icon: "ri-inbox-archive-line",
    title: "提交线索",
    desc: "通过匿名投稿入口上传私信截图、聊天记录或事件经过，可只填必要信息，联系方式可留空。",
  },
  {
    id: "02",
    icon: "ri-search-eye-line",
    title: "初步核验",
    desc: "编辑组在 72 小时内判断线索是否具备可报道价值，核查截图是否存在拼接、去头去尾等失真情况。",
  },
  {
    id: "03",
    icon: "ri-links-line",
    title: "交叉求证",
    desc: "向多方当事人、同期观众或其他知情者交叉比对，保留原始证据链与时间戳，缺失环节会主动向投稿人回访。",
  },
  {
    id: "04",
    icon: "ri-file-shield-2-line",
    title: "核实后发布",
    desc: "证据充分才进入存档发布；证据不足或涉及恶意造谣的，直接退回并说明原因，不会公开任何未经核实的内容。",
  },
];

export const categories = [
  {
    icon: "ri-chat-private-line",
    title: "私信截图",
    desc: "网红与粉丝、合作方之间的私信往来，需保留完整对话上下文与时间信息。",
    count: "6,240 条",
    tint: "primary",
  },
  {
    icon: "ri-message-3-line",
    title: "聊天记录",
    desc: "群聊、工作室内部沟通记录，重点征集带有具体承诺、报价或指令的内容。",
    count: "4,118 条",
    tint: "accent",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "带货售后",
    desc: "直播间下单后的商品质量、发货延迟、退款纠纷，欢迎附带订单与客服沟通记录。",
    count: "5,530 条",
    tint: "secondary",
  },
  {
    icon: "ri-live-line",
    title: "直播事故",
    desc: "直播过程中的口误、争议言论、临时下播等现场情况，录屏与时间节点尤为重要。",
    count: "2,876 条",
    tint: "primary",
  },
  {
    icon: "ri-user-heart-line",
    title: "人设争议",
    desc: "公开形象与真实言行存在明显出入的线索，需提供可验证的对比材料。",
    count: "3,092 条",
    tint: "accent",
  },
  {
    icon: "ri-file-text-line",
    title: "商务纠纷",
    desc: "品牌方与网红之间的合作违约、数据造假、虚假宣传等商务层面的争议线索。",
    count: "1,744 条",
    tint: "secondary",
  },
];

export const cases = [
  {
    id: "case-1",
    tag: "带货售后",
    title: "某平台头部带货主播「预售延期」纠纷线索完成核验",
    summary:
      "多位消费者提供同一场直播的订单截图与客服记录，时间线一致。经比对，商品预售承诺与实际发货时间存在明显出入，平台已介入协调。",
    date: "2026-08-28",
    status: "已核实",
    evidence: "订单截图 14 份 · 客服记录 6 段",
  },
  {
    id: "case-2",
    tag: "私信截图",
    title: "美妆博主「私下报价」与公开口径不一致线索退回",
    summary:
      "投稿截图缺少开头的询价环节，无法确认对话主体与完整语境。已向投稿人说明原因并邀请补充原始聊天导出文件。",
    date: "2026-08-25",
    status: "待补充",
    evidence: "截图 3 张 · 需补充上下文",
  },
  {
    id: "case-3",
    tag: "直播事故",
    title: "游戏区主播连麦言论争议：多方比对后确认无剪辑",
    summary:
      "投稿录屏与另外两名在场观众的完整录像时间轴一致，排除剪辑可能。相关言论已被存档，等待当事人回应。",
    date: "2026-08-21",
    status: "已核实",
    evidence: "录屏 3 段 · 时间戳一致",
  },
  {
    id: "case-4",
    tag: "商务纠纷",
    title: "某品牌与探店博主「数据注水」争议进入交叉求证阶段",
    summary:
      "品牌方提供投放数据后台截图，投稿博主方则提供完整视频素材。双方数据口径存在差异，编辑组正在核对第三方播放记录。",
    date: "2026-08-18",
    status: "核验中",
    evidence: "后台数据 2 份 · 素材 1 套",
  },
  {
    id: "case-5",
    tag: "人设争议",
    title: "「公益直播」善款去向线索：核验后证据不足，不予发布",
    summary:
      "投稿内容多为转述与二手信息，缺少可直接验证的凭证。为避免误伤，编辑组决定不予发布，并提醒投稿人勿扩散未经证实内容。",
    date: "2026-08-12",
    status: "未通过",
    evidence: "转述材料 · 无原始凭证",
  },
  {
    id: "case-6",
    tag: "聊天记录",
    title: "网红工作室「内部指令」群聊记录线索完成脱敏存档",
    summary:
      "投稿人提供完整群聊导出文件，包含组织刷量、统一话术等具体指令。已对无关人员信息脱敏，仅保留与事件相关的对话段落。",
    date: "2026-08-06",
    status: "已核实",
    evidence: "群聊导出 1 份 · 已脱敏",
  },
];

export const faqs = [
  {
    q: "投稿爆料需要实名吗？可以完全匿名吗？",
    a: "可以完全匿名投稿。投稿表单中的联系方式为选填项，你可以只提交线索内容。为保护投稿人，我们不会公开任何可识别投稿人身份的账号、头像与联系方式，内部也仅限核验编辑查看。",
  },
  {
    q: "什么样的线索更容易被采纳？",
    a: "带有原始凭证的线索采纳率最高，例如未经裁剪的聊天记录导出文件、带时间戳的录屏、可核对的订单与后台截图。只有结论、没有材料的转述类内容通常无法通过核验。",
  },
  {
    q: "你们会怎样核验一条爆料？",
    a: "核验分三步：先判断材料是否完整、是否存在拼接或去头去尾；再向多方当事人与知情者交叉比对时间线与细节；最后确认证据链闭环才进入发布。缺失关键环节时，我们会主动联系投稿人补充。",
  },
  {
    q: "为什么有些线索最终没有发布？",
    a: "证据不足、材料失真、仅涉及个人隐私但无公共利益，或存在明显恶意造谣嫌疑的线索，我们都会退回。退稿不代表线索没有价值，多数情况是缺少可验证的凭证或关键上下文。",
  },
  {
    q: "投稿后多久会有反馈？",
    a: "编辑组会在 72 小时内完成初步判断。若留下联系方式，我们会同步处理进度；若为完全匿名投稿，结果将在「已核实爆料存档」中体现，你也可以通过匿名编号后续查询。",
  },
  {
    q: "爆料内容会不会被随意公开？",
    a: "不会。所有材料进入核验流程后默认保密，仅在证据充分且通过编辑复核后才会发布，且发布前会对无关个人信息做脱敏处理。未经核实的线索永远停留在内部。",
  },
];

export const aboutValues = [
  {
    icon: "ri-shield-check-line",
    title: "核实优先",
    desc: "不抢首发，不博眼球。任何一条爆料都必须完成交叉求证，证据不闭环就不发布。",
  },
  {
    icon: "ri-shield-user-line",
    title: "保护投稿人",
    desc: "匿名机制贯穿始终，材料脱敏后才进入公开环节，投稿人身份不作任何形式的披露。",
  },
  {
    icon: "ri-scales-3-line",
    title: "拒绝造谣",
    desc: "不鼓励情绪化攻击与人身曝光。涉及隐私但无公共利益的内容，一律不采纳。",
  },
  {
    icon: "ri-refresh-line",
    title: "允许更正",
    desc: "当事人可提交反证材料，核验属实后我们会更新或撤下相关存档，并标注更正说明。",
  },
];